import React from 'react';
const PeerCardSummary = ({ summary }) => {
  return summary ? <div className="peer-cards__body--summary">{summary}</div> : null;
};

export default PeerCardSummary;
